import React, { forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericSettingsPane, GenericSettingsPaneHandle } from './GenericSettingsPane';
import { PaneHandle, PaneProps } from '../accountParameter.types';
import { useStoreState } from '../../../../models/hooks';
import { DEFAULT_FILTER_CANDIDATE_BY_DAYS } from '../../../../utils/candidatesUtils';

export const CandidatePane = forwardRef<PaneHandle, PaneProps>(({ onSave, setDirty, showActions }, ref) => {
  const { t } = useTranslation('accountParameter');
  const genericPaneRef = useRef<GenericSettingsPaneHandle>(null);
  const account = useStoreState((state) => state.app.accounts);

  useImperativeHandle(ref, () => ({
    save: () => genericPaneRef.current?.save(),
    reset: () => genericPaneRef.current?.reset(),
  }));

  const items = useMemo(
    () => [
      {
        key: 'filterCandidateByDays',
        label: t('candidatePane.filterCandidateByDays'),
        description: t('candidatePane.filterCandidateByDaysDescription'),
        value: account?.configuration?.filterCandidateByDays || DEFAULT_FILTER_CANDIDATE_BY_DAYS,
        unit: t('candidatePane.days'),
        min: 1,
        max: 365,
        type: 'number' as const,
        isRequired: true,
      },
    ],
    [account, t],
  );

  return (
    <GenericSettingsPane ref={genericPaneRef} onSave={onSave} setDirty={setDirty} showInlineActions={showActions} items={items} />
  );
});

CandidatePane.displayName = 'CandidatePane';
